import Vue from 'vue';
import URI from 'urijs'
import { config } from '@/plugins/env.config'
import { decamelizeKeys } from 'humps';

async function getBeneficiary(beneficiaryId, attemptNumber = 1) {
  
  const getBeneficiaryUri = new URI(config.apiBaseUrl)
  getBeneficiaryUri.segment('plans')
  getBeneficiaryUri.segment('v1')
  getBeneficiaryUri.segment('beneficiaries')
  getBeneficiaryUri.segment(beneficiaryId.toString())

  try{
    return await Vue.prototype.$http.get(getBeneficiaryUri.toString())
  }catch(error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getBeneficiary(beneficiaryId, attemptNumber + 1)
    }

    throw error
  }
}

async function updateBeneficiary(beneficiaryId, payload, attemptNumber = 1) {

  const updateBeneficiaryUri = new URI(config.apiBaseUrl)
  updateBeneficiaryUri.segment('plans')
  updateBeneficiaryUri.segment('v1')
  updateBeneficiaryUri.segment('beneficiaries')
  updateBeneficiaryUri.segment(beneficiaryId.toString())

  payload = decamelizeKeys(payload)

  try{
    return await Vue.prototype.$http.post(updateBeneficiaryUri.toString(), payload)
  }catch(error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response ? error.response : error
    const status = response.status ? response.status : error.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return updateBeneficiary(beneficiaryId, payload, attemptNumber = 1)
    }

    throw error
  }
}

export {
  getBeneficiary,
  updateBeneficiary
}